import React, { useState } from 'react';
import { makeStyles } from 'design-system/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useSlate } from 'slate-react';
import API from '@scale/frontend-lib/dashboard-api';
import { Transforms } from 'slate';
import _ from 'lodash';
// eslint-disable-next-line restrict-imports/restrict-imports
import theme from 'design-system/product/theme';

const useStyles = makeStyles({
  sectionButton: {
    outline: 'none',
    background: '#F8F8F8',
    border: 'none',
    padding: '4px 6px',
    marginLeft: 6,
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 500,
    color: '#DD45D3',
    cursor: 'pointer',
    transition: 'background 120ms ease-out',
    '&:hover': {
      background: theme.colors.periwinkle25,
    },
  },
  questionMenu: {
    position: 'absolute',
    top: 32,
    left: 6,
    background: 'white',
    padding: 4,
    borderRadius: 8,
    minWidth: 200,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 400,
    padding: 8,
    borderRadius: 4,
    cursor: 'pointer',
    '&:hover': {
      background: theme.colors.periwinkle25,
    },
  },
});

interface AddSectionProps {
  lastSelection: $FIXME;
  shouldShowLabeledExamples: boolean;
}

export const AddSection: React.FC<AddSectionProps> = ({
  lastSelection,
  shouldShowLabeledExamples,
}) => {
  const classes = useStyles();
  const [menuVisible, toggleMenu] = useState(false);
  const editor = useSlate();

  const handleSelect = (itemName: string) => {
    let itemNode;
    if (itemName === 'iframe') {
      itemNode = { type: 'iframe', url: '', children: [{ text: '' }] };
    } else if (itemName === 'exampleLabel') {
      itemNode = {
        type: 'label-section',
        // @ts-ignore
        labelName: _.startCase(_.toLower('Label Name...')),
        examples: [],
        children: [{ text: '' }],
      };
    }
    if (itemNode) {
      Transforms.select(editor, lastSelection);
      // @ts-ignore
      Transforms.insertNodes(editor, itemNode);
      Transforms.insertNodes(editor, { type: 'paragraph', children: [{ text: ' ' }] });
    }
    toggleMenu(!menuVisible);
  };

  const uploadImages = async (files: FileList | null) => {
    if (files && files.length > 0) {
      const { assetId } = await API.selfserve.uploadInstructionImage({ file: files.item(0) });
      if (assetId) {
        const itemNode = {
          type: 'image',
          assetId,
          children: [{ text: '' }],
        };
        Transforms.select(editor, lastSelection);
        // @ts-ignore
        Transforms.insertNodes(editor, itemNode);
        Transforms.insertNodes(editor, { type: 'paragraph', children: [{ text: ' ' }] });
      }
    }
    toggleMenu(!menuVisible);
  };

  return (
    <div style={{ position: 'relative', margin: '16px 0' }}>
      <button
        style={{ color: theme.colors.periwinkle100 }}
        className={classes.sectionButton}
        onClick={e => {
          e.preventDefault();
          toggleMenu(!menuVisible);
        }}
      >
        Insert
      </button>
      {menuVisible && (
        <div className={classes.questionMenu}>
          <div className={classes.menuItem} onClick={() => handleSelect('iframe')}>
            <FontAwesomeIcon
              icon="anchor"
              color="#555"
              style={{ width: 16, height: 16, marginRight: 12 }}
            />
            Iframe (embed URL)
          </div>
          <label htmlFor="file-upload">
            <div className={classes.menuItem}>
              <FontAwesomeIcon
                icon="image"
                color="#555"
                style={{ width: 16, height: 16, marginRight: 12 }}
              />
              Image or PDF
            </div>
          </label>
          <input
            style={{ display: 'none', opacity: 0 }}
            id="file-upload"
            type="file"
            accept="image/*,application/pdf"
            onChange={e => uploadImages(e.target.files)}
          />
          {shouldShowLabeledExamples && (
            <div className={classes.menuItem} onClick={() => handleSelect('exampleLabel')}>
              <FontAwesomeIcon
                icon="tag"
                color="#555"
                style={{ width: 16, height: 16, marginRight: 12 }}
              />
              Labeled Examples
            </div>
          )}
        </div>
      )}
    </div>
  );
};
